import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 2,
};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  flex: 1,
  minWidth: 0,
};

export const subtitleRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
};

export const subtitleDot: SxStyle = {
  width: 4,
  height: 4,
  borderRadius: '50%',
  bgcolor: 'grey.400',
};

export const dot: SxStyle = {
  width: '6px !important',
  minWidth: '6px !important',
  height: '6px !important',
};
